import React, { useState, useEffect } from 'react';
import { useSelector } from 'umi';
import GeneralIFrame from '@gp/components/GeneralIFrame';
import { queryTableauUrl, reportOperationLog } from '@gp/services/global';
import { ALL_REPORT_OPERATION_LOG } from '@gp/constants/operationLogParams';
import { LEFT_MENU_NAMESPACE, GPOPLeftMenuModelState } from '@gp/models/gpopLeftMenuList';
import './index.scss';

export default function StudioBusinessMetricsTableau() {
  const { menuList }: GPOPLeftMenuModelState = useSelector((state: any) => state?.[LEFT_MENU_NAMESPACE]);
  const [tableauUrl, setTableauUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const init = async (tableauSiteId: string) => {
    try {
      setIsLoading(true);
      const urls = await queryTableauUrl({
        tableau_site_id: tableauSiteId,
      });
      const url = window.location.origin?.includes('woa.com')
        ? urls?.full_url_inner
        : urls?.full_url;
      setTableauUrl(url || '');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!menuList) return;

    let targetMenuItem: any = null;
    menuList?.forEach((t: any) => {
      if (t?.id === '140') {
        t?.sub_menus?.forEach((it: any) => {
          if (it?.id === '145') {
            targetMenuItem = it;
          }
        });
      }
    });
    if (targetMenuItem) {
      init(targetMenuItem?.tableau_site_id);
      reportOperationLog(ALL_REPORT_OPERATION_LOG['STUDIO_BUSINESS_METRICS']);
    }
  }, [menuList]);

  return (
    <hgroup className="tableau-container">
      <GeneralIFrame isLoading={isLoading} src={tableauUrl} />
    </hgroup>
  );
}
